// src/index.ts
'use client'

export { CookieConsent } from './components/CookieConsent'
export { useCookieConsent } from './hooks/useCookieConsent'
export { showCookieSettings, revokeConsent, exportConsent } from './components/api'
export { getBlockedScriptsDebugInfo } from './core/script-blocker'

// Export Consent Mode V2 helpers for advanced usage
export {
  initConsentMode,
  updateConsentMode,
  setConsentDefault,
  setConsentDefaultForRegion,
  enableUrlPassthrough,
  enableAdsDataRedaction,
} from './integrations/consent-mode'

export type {
  ConsentCategory,
  ConsentMode,
  Preset,
  Position,
  Size,
  Spacing,
  BorderRadius,
  Shadow,
  BorderWidth,
  FontSize,
  ButtonShape,
  ButtonSize,
  AnimationDirection,
  StyleConfig,
  CategoryDefinition,
  ConsentState,
  ConsentRecord,
  TextsConfig,
  LinkConfig,
  IntegrationConfig,
  RemoteConfig,
  CookieConsentConfig,
  CookieConsentAPI,
} from './types'

// Export Consent Mode V2 types
export type { ConsentModeState } from './integrations/consent-mode'

export type { CookieConsentProps } from './components/CookieConsent'
export type { UseCookieConsentReturn } from './hooks/useCookieConsent'
